define('shared/initializer/form/adapterFactory',[
    'shared/lib/RSVP',
    'shared/page/apiVersion',
    './adapters/Base',
    './adapters/Member',
    './adapters/CreditCardPayment',
    './adapters/PayPalPayment',
    './adapters/LeadLegacy',
    './adapters/OnlineSalesLegacy',
    './adapters/OnlineSales',
    './adapters/DirectDebitPayment',
    './adapters/Generic',
    './adapters/Redemption',
    './adapters/Lead',
    './adapters/WorldpayPayment',
    './adapters/Login',
    './adapters/LoginCardinal',
    './adapters/TermsCardinal',
    './adapters/ForgotPasswordCardinal',
    './adapters/ForgetPassword',
    './adapters/ResetPassword',
    './adapters/Upsell',
    './adapters/AdyenPayment',
    './adapters/AdyenUpdatePayment',
    './newHouseAdapters/Member',
    './newHouseAdapters/CreditCardPayment',
    './newHouseAdapters/DirectDebitPayment',
    './newHouseAdapters/Login',
    './newHouseAdapters/Upsell',
    './newHouseAdapters/Redemption',
    './newHouseAdapters/Lead',
    './newHouseAdapters/TermsAndConditions',
    './newHouseAdapters/ForgetPassword',
    './newHouseAdapters/CreditCardUpdate',
    './newHouseAdapters/DirectDebitUpdate',
    './newHouseAdapters/AdyenPayment',
],
function (
    RSVP,
    getAPIVersion,
    BaseAdapter,
    MemberAdapter,
    CreditCardPaymentAdapter,
    PayPalPaymentAdapter,
    LeadLegacyAdapter,
    OnlineSalesLegacyAdapter,
    OnlineSalesAdapter,
    DirectDebitPayment,
    Generic,
    Redemption,
    LeadAdapter,
    WorldpayPayment,
    Login,
    LoginCardinal,
    TermsCardinal,
    ForgotPasswordCardinal,
    ForgetPassword,
    ResetPassword,
    Upsell,
    OldHouseAdyenPayment,
    OldHouseAdyenUpdatePayment,
    NewHouseMember,
    NewHouseCreditCardPayment,
    NewHouseDirectDebitPayment,
    NewHouseLogin,
    NewHouseUpsell,
    NewHouseRedemption,
    NewHouseLead,
    NewHouseTermsAndConditions,
    NewHouseForgetPassword,
    CreditCardUpdate,
    DirectDebitUpdate,
    AdyenPayment
) {
    'use strict';

    var EX_TYPE_NOT_SUPPORTED = 'Form type is not supported';

    var ADAPTERS = {
        'member': MemberAdapter,
        'creditcard': CreditCardPaymentAdapter,
        'existingcreditcard': CreditCardPaymentAdapter,
        'paypal': PayPalPaymentAdapter,
        'directdebit': DirectDebitPayment,
        'oe': LeadAdapter,
        'ee': LeadAdapter,
        'ot': LeadAdapter,
        'fc': LeadAdapter,
        'ft': LeadAdapter,
        'ce': LeadAdapter,
        'os': OnlineSalesAdapter,
        'sb': LeadAdapter,
        'fl': LeadAdapter,
        'generic': Generic,
        'redemption': Redemption,
        'worldpay': WorldpayPayment,
        'login': Login,
        'logincardinal': LoginCardinal,
        'termscardinal': TermsCardinal,
        'forgotpasswordcardinal': ForgotPasswordCardinal,
        'forgetpassword': ForgetPassword,
        'resetpassword': ResetPassword,
        'upsell': Upsell,
        'adyen': OldHouseAdyenPayment,
        'adyenupdate': OldHouseAdyenUpdatePayment
    };

    var ADAPTERS_LEAD_LEGACY = {
        'oe': LeadLegacyAdapter,
        'ee': LeadLegacyAdapter,
        'ot': LeadLegacyAdapter,
        'fc': LeadLegacyAdapter,
        'ft': LeadLegacyAdapter,
        'ce': LeadLegacyAdapter,
        'sb': LeadLegacyAdapter,
        'fl': LeadLegacyAdapter,
        'os': OnlineSalesLegacyAdapter
    };

    var ADAPTERS_NEW_HOUSE = {
        'member': NewHouseMember,
        'creditcard': NewHouseCreditCardPayment,
        'directdebit': NewHouseDirectDebitPayment,
        'login': NewHouseLogin,
        'upsell': NewHouseUpsell,
        'redemption': NewHouseRedemption,
        'oe': NewHouseLead,
        'ee': NewHouseLead,
        'ot': NewHouseLead,
        'fc': NewHouseLead,
        'ft': NewHouseLead,
        'ce': NewHouseLead,
        'sb': NewHouseLead,
        'fl': NewHouseLead,
        'termsandconditions': NewHouseTermsAndConditions,
        'forgetpassword': NewHouseForgetPassword,
        'creditcardupdate': CreditCardUpdate,
        'directdebitupdate': DirectDebitUpdate,
        'adyen': AdyenPayment
    };

    return {
        create: function (options) {
            return getAPIVersion()
                .then(function (apiVersion) {

                    if (options == null) {
                        throw new Error(EX_TYPE_NOT_SUPPORTED);
                    }

                    var TheAdapter = null;

                    if (options.options && (options.options.leadLegacy || options.options.onlineSalesLegacy)){
                        TheAdapter = ADAPTERS_LEAD_LEGACY[options.type];
                    }

                    if (apiVersion === 'new-house') {
                        TheAdapter = ADAPTERS_NEW_HOUSE[options.type];
                    }

                    if (!TheAdapter){
                        TheAdapter = ADAPTERS[options.type];
                    }

                    if (TheAdapter == null &&
                        options.options != null &&
                        typeof options.options.Adapter === 'function'
                    ) {
                        TheAdapter = options.options.Adapter;
                    }

                    if (TheAdapter == null) {
                        throw new Error(EX_TYPE_NOT_SUPPORTED);
                    }

                    return new TheAdapter(options.$form, options.type, options.options);
                });
        }
    };
});

